import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import AppLogo from '../../components/AppLogo';

var InactifCalendarPage = function InactifCalendarPage() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col min-h-screen pt-16 pb-12 bg-white",
    children: [/*#__PURE__*/_jsxs("main", {
      className: "flex flex-col justify-center flex-grow w-full px-4 mx-auto max-w-7xl sm:px-6 lg:px-8",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex justify-center flex-shrink-0",
        children: /*#__PURE__*/_jsx("div", {
          className: "w-16 h-12 mx-auto",
          children: /*#__PURE__*/_jsx(AppLogo, {})
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "py-16",
        children: /*#__PURE__*/_jsxs("div", {
          className: "text-center",
          children: [/*#__PURE__*/_jsx("h1", {
            className: "mt-2 text-2xl font-extrabold tracking-tight text-gray-900 sm:text-5xl",
            children: t('public.inactiveCalendarTitle')
          }), /*#__PURE__*/_jsx("p", {
            className: "mt-2 text-base text-gray-500",
            children: t('public.inactiveCalendarMessage')
          }), /*#__PURE__*/_jsx("div", {
            className: "mt-6",
            children: /*#__PURE__*/_jsx(Link, {
              href: {
                pathname: '/'
              },
              children: /*#__PURE__*/_jsxs("a", {
                className: "text-base font-medium text-indigo-600 hover:text-indigo-500",
                children: [t('public.inactiveCalendarButton'), /*#__PURE__*/_jsx("span", {
                  "aria-hidden": "true",
                  children: " \u2192"
                })]
              })
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("footer", {
      className: "flex-shrink-0 w-full px-4 mx-auto max-w-7xl sm:px-6 lg:px-8",
      children: /*#__PURE__*/_jsxs("nav", {
        className: "flex justify-center space-x-4",
        children: [/*#__PURE__*/_jsx(Link, {
          href: "/",
          children: /*#__PURE__*/_jsx("a", {
            className: "text-sm font-medium text-gray-500 hover:text-gray-600",
            children: "Contact Support"
          })
        }), /*#__PURE__*/_jsx("span", {
          className: "inline-block border-l border-gray-300",
          "aria-hidden": "true"
        }), /*#__PURE__*/_jsx(Link, {
          href: "/",
          children: /*#__PURE__*/_jsx("a", {
            className: "text-sm font-medium text-gray-500 hover:text-gray-600",
            children: "Status"
          })
        }), /*#__PURE__*/_jsx("span", {
          className: "inline-block border-l border-gray-300",
          "aria-hidden": "true"
        }), /*#__PURE__*/_jsx(Link, {
          href: "https://twitter.com/Yalendar_App",
          children: /*#__PURE__*/_jsx("a", {
            className: "text-sm font-medium text-gray-500 hover:text-gray-600",
            children: "Twitter"
          })
        })]
      })
    })]
  });
};

export default InactifCalendarPage;